import { cn } from '@commenda/utils';

interface IGripIconProps {
  className?: string;
}

/** Six-dot (2×3) drag grip; the icon set only ships 3×3 and single-column dot grids. */
export const GripIcon = ({ className }: IGripIconProps) => (
  <svg
    viewBox="0 0 8 14"
    fill="currentColor"
    aria-hidden="true"
    className={cn('h-3.5 w-2', className)}
  >
    {[1, 7, 13].map((cy) => (
      <g key={cy}>
        <circle cx="2" cy={cy} r="1.15" />
        <circle cx="6" cy={cy} r="1.15" />
      </g>
    ))}
  </svg>
);
